import * as ast from '../generated/ast.js';
export const RichAssetTypesDisplayNames = {
    [ast.RichAssetAudio.$type]: 'audio',
    [ast.RichAssetButton.$type]: 'button',
    [ast.RichAssetButtons.$type]: 'buttons',
    [ast.RichAssetCarousel.$type]: 'carousel',
    [ast.RichAssetDatePicker.$type]: 'datepicker',
    [ast.RichAssetDeepLink.$type]: 'deeplink',
    [ast.RichAssetDocument.$type]: 'document',
    [ast.RichAssetFileUpload.$type]: 'file_upload',
    [ast.RichAssetImageButton.$type]: 'imagebutton',
    [ast.RichAssetImage.$type]: 'image',
    [ast.RichAssetListPicker.$type]: 'listpicker',
    [ast.RichAssetLocation.$type]: 'location',
    [ast.RichAssetNone.$type]: 'none',
    [ast.RichAssetPersistentMenu.$type]: 'persistent_menu',
    [ast.RichAssetPng.$type]: 'png',
    [ast.RichAssetQuickReply.$type]: 'quick_reply',
    [ast.RichAssetSecure.$type]: 'secure',
    [ast.RichAssetSelection.$type]: 'selection',
    [ast.RichAssetStar.$type]: 'star',
    [ast.RichAssetTimePicker.$type]: 'timepicker',
    [ast.RichAssetUnknown.$type]: 'unknown',
    [ast.RichAssetVideo.$type]: 'video',
    [ast.RichAssetWebView.$type]: 'webview',
};
export const PropertyTypesDisplayNames = {
    [ast.TypeStaticProperty.$type]: 'type',
    [ast.TypeDynamicProperty.$type]: 'type',
    [ast.ButtonOptionsArrayProperty.$type]: 'options',
    [ast.LabelProperty.$type]: 'label',
    [ast.DestProperty.$type]: 'dest',
    [ast.UrlProperty.$type]: 'url',
    [ast.UrlsProperty.$type]: 'url',
    [ast.LoopProperty.$type]: 'loop',
    [ast.IconPrefixProperty.$type]: 'icon_prefix',
    [ast.IconSuffixProperty.$type]: 'icon_suffix',
    [ast.VariablesArrayProperty.$type]: 'vars',
    [ast.TitleProperty.$type]: 'title',
    [ast.ImageProperty.$type]: 'image',
    [ast.AltTextProperty.$type]: 'alt_text',
    [ast.SubTitleProperty.$type]: 'subtitle',
    [ast.OptTextProperty.$type]: 'opt_text',
    [ast.AdditionalCtaArrayProperty.$type]: 'additional_cta',
    [ast.MessageProperty.$type]: 'message',
    [ast.IosUrlProperty.$type]: 'ios_url',
    [ast.AndroidUrlProperty.$type]: 'android_url',
    [ast.IosStoreProperty.$type]: 'ios_store',
    [ast.AndroidStoreProperty.$type]: 'android_store',
    [ast.UploadLabelProperty.$type]: 'upload_label',
    [ast.CancelLabelProperty.$type]: 'cancel_label',
    [ast.EndpointProperty.$type]: 'endpoint',
    [ast.ActionScriptProperty.$type]: 'action_script',
    [ast.HeadersProperty.$type]: 'headers',
    [ast.ImageButtonOptionsArrayProperty.$type]: 'options',
    [ast.ListPickerOptionsArrayProperty.$type]: 'options',
    [ast.DescriptionProperty.$type]: 'description',
    [ast.PersistentMenuOptionsArrayProperty.$type]: 'options',
    [ast.SetValueProperty.$type]: 'set_value',
    [ast.QuickReplyOptionsArrayProperty.$type]: 'options',
    [ast.CtaLabelProperty.$type]: 'cta_label',
    [ast.StarOptionsArrayProperty.$type]: 'options',
    [ast.InlineProperty.$type]: 'inline',
    [ast.CloseMessageProperty.$type]: 'close_message',
    [ast.SourceNodeProperty.$type]: 'source_node',
    [ast.SourceVariableProperty.$type]: 'source_var',
};
//# sourceMappingURL=mappings.js.map